require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./architecture-auth-with-firebase-inherited-widget.json") })
        }
      }, "path---architecture-auth-with-firebase-inherited-widget");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---architecture-auth-with-firebase-inherited-widget!./.cache/json/architecture-auth-with-firebase-inherited-widget.json
// module id = 366
// module chunks = 231608221292675